module.exports = __webpack_public_path__ + "static/media/jo.f787b734.webp";